export default () => (
  <div>
    <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.6665 4.66669V22.1667C4.6665 22.4761 4.78942 22.7729 5.00821 22.9916C5.22701 23.2104 5.52375 23.3334 5.83317 23.3334H23.3332M9.33317 18.6667L12.2498 12.25L15.7498 15.75L20.1517 8.16669L23.3332 11.2782"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
);
